import { render, staticRenderFns } from "./SaveTemplateModal.vue?vue&type=template&id=5def427a&"
import script from "./SaveTemplateModal.vue?vue&type=script&lang=js&"
export * from "./SaveTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports